import { Component, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DxAspNetDataXsrfAwareService } from '@tools';

import DataSource from 'devextreme/data/data_source';

import { LanguageService, __i18n } from '@localisation';
import { UrlEnhancerService } from '@url';
import { ClxDataGridComponent } from '@forms';
import * as moment from 'moment';
import { NumberFormatService } from '@converter';

@Component({
    selector: 'history-list',
    templateUrl: './history-list.template.html',
    standalone: false
})
export class HistoryListComponent {

    constructor(
        private dxAspNetXsrfAwareService: DxAspNetDataXsrfAwareService,
        private urlEnhancer: UrlEnhancerService,
        private changeDetectorRef: ChangeDetectorRef
    ){
    }

    public source: any;

    @ViewChild(ClxDataGridComponent, { static: false })
    public grid: ClxDataGridComponent;

    @Input()
    public url: string;

    @Input()
    public id: string;

    @Input()
    public testId: string;

    public remoteOperations = {
        paging: true, filtering: true, sorting: true, grouping: true, summary: true, groupPaging: true
    };

    public ngAfterViewInit(){
        let url = this.url;
        url = this.urlEnhancer.replaceParams(url);

        this.source = new DataSource({
            paginate: true,
            store: this.dxAspNetXsrfAwareService.createStore({
                loadUrl: url,
                loadMethod: 'POST',
                key: 'Id'
            })
        });

        this.changeDetectorRef.detectChanges();
    }

    public async refresh(){
        await this.source.reload();
    }
}
